import { render } from "./QueueFormPage.vue?vue&type=template&id=5bd03fde&ts=true"
import script from "./QueueFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueueFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/queue/QueueFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bd03fde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bd03fde', __exports__)) {
    api.reload('5bd03fde', __exports__)
  }
  
  module.hot.accept("./QueueFormPage.vue?vue&type=template&id=5bd03fde&ts=true", () => {
    api.rerender('5bd03fde', render)
  })

}


export default __exports__